// 接口域名
const host = "";

module.exports = {
  host: host,
  storage: host,
  systemName: '尺半充值系统',
  homeUrl: "/backend/statistic/dashboard",
  loginUrl: "/backend/auth/login",
};
